module.exports = __webpack_public_path__ + "img/dropdown-blob-darkgrey.4f03907f.svg";